module.exports = __webpack_public_path__ + "img/cloud.f3a7484e.png";